import React from 'react';
import { Navigate } from 'react-router-dom';
import type { UserRole } from '@/types';
import { SalesLandingPage } from './roles/SalesLandingPage';
import { ServiceAEDashboard } from './roles/ServiceAEDashboard';
import { ExceptionsDashboard } from './roles/ExceptionsDashboard';
import { LeadershipDashboard } from './roles/LeadershipDashboard';

interface RoleDashboardProps {
  role: UserRole;
}

/**
 * Role-based dashboard component that renders the appropriate dashboard
 * based on the user's role
 */
export function RoleDashboard({ role }: RoleDashboardProps) {
  switch (role) {
    case 'sales_ae':
    case 'sales_support':
      return <SalesLandingPage />;
    
    case 'service_ae':
      return <ServiceAEDashboard />;
    
    case 'charting_member':
    case 'charting_manager':
      return <Navigate to="/charting" replace />;
    
    case 'exceptions_member':
      return <ExceptionsDashboard />;
    
    case 'sales_vp':
    case 'gvp':
    case 'rvp':
    case 'adops_leadership':
      return <LeadershipDashboard role={role} />;
    
    case 'admin':
      // Admin gets leadership-style dashboard with read-only access
      return <LeadershipDashboard role={role} />;
    
    default:
      return (
        <div className="text-center py-12">
          <p className="text-neutral-400">Dashboard not configured for this role</p>
        </div>
      );
  }
}
